<template>
  <section id="hero">
    <img src="/images/hero.jpg" alt="">
    <div class="post-hero" flex gapped>
      <div class="post-hero-info" flex flex-column flex-center gapped>
        <h1 noselect nopointer slideDown>¡Hola!</h1>
        <p noselect nopointer slide>Mi nombre es paola, diseñadora de interiores, <br> especialista en remodelaciones.</p>
        <h2 noselect nopointer slideUp radius-border>Agendá una cita gratuita de 30 minutos <br> y te voy a contar como transformar tus espacios.</h2>
        <div class="post-hero-info-button">
          <a href="#contacto">
            <p noselect slide class="m-0">¡QUIERO UNA CITA!</p>
          </a>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
</script>

<style scoped lang="scss">
img {
  height: calc(100vh - var(--header-height));
  width: 100%;
  object-fit: cover;
}

h1 {
  font-size: 6em;
}

p {
  font-size: 1.5em;
}

h2 {
  background: rgba(255, 255, 255, 0.5);
  padding: .5em;

  max-width: 900px;
}

#hero {
  width: 100%;
  min-height: calc(100vh - var(--header-height));

  position: relative;
}

.post-hero {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
}

.post-hero-info {
  width: 50%;
  height: 100%;

  padding: 3em;
  background: rgba(255, 255, 255, 0.1); /* White with transparency */
  backdrop-filter: blur(20px);
}

.post-hero-info-button {
  width: 100%;

  padding-left: 1em;

  p {
    font-size: 1em;
    background: var(--primary);
    color: white;
    padding: 1em 2em;

    cursor: pointer;

    transition: var(--duration);
    &:hover {
      color: var(--primary);
      background: white;
    }
  }
}

@media screen and (max-width: 1000px) {
  .post-hero-info {
    width: 70%;
  }
}

@media screen and (max-width: 630px) {
  h1 {
    font-size: 4em;
  }

  p {
    font-size: 1.2em;
    text-align: center;
  }

  .post-hero-info {
    width: 100%;
  }
}

</style>